import { BlackServicesInactive } from '@assets/icons';
import SearchComponent from '@components/inputs/search/Search.component';
import { Colors } from '@constants/colors.constants';
import { Add } from '@mui/icons-material';
import InventoryIcon from '@mui/icons-material/Inventory';
import { Box, Button, Divider, FormControlLabel, Radio, RadioGroup, Stack, styled, Typography } from '@mui/material';
import { emitOnce } from '@ngneat/elf';
import { useObservable } from '@ngneat/react-rxjs';
import AllOffers from '@screens/admin/audits/audits-offer-follow-up/AllOffers';
import DetailContainer from '@screens/admin/audits/audits-offer-follow-up/DetailContainer';
import DetailPartner from '@screens/admin/audits/audits-offer-follow-up/DetailPartner';
import ExpiredOffers from '@screens/admin/audits/audits-offer-follow-up/ExpiredOffers';
import HistoryOffer from '@screens/admin/audits/audits-offer-follow-up/HistoryOffer';
import LastAnswer from '@screens/admin/audits/audits-offer-follow-up/LastAnswer';
import NewProposal from '@screens/admin/audits/audits-offer-follow-up/NewProposal.modal';
import RecentOffers from '@screens/admin/audits/audits-offer-follow-up/RecentOffers';
import {
  SupplierUnitsProposalDto
} from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.model';
import {
  auditsProposalSuppliersQuery
} from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.query';
import {
  auditProposalSuppliersServices
} from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.services';
import { useSnackbar } from 'notistack';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { switchMap } from 'rxjs';
import { auditDetailsQuery } from '../../../../../store/audits/audit-details/audits-details.query';
import { auditsOfferService } from '../../../../../store/audits/audit-offer/audit-offer.services';
import { auditsOperationQuery } from '../../../../../store/audits/audits-operation/audit-operation.query';
import {
  AuditOperation,
  AuditOperationStepTypeEnum
} from '../../../../../store/audits/audits-operation/audits-operation.model';
import { auditsOperationService } from '../../../../../store/audits/audits-operation/audits-operation.service';
import { suppliersUnitsService } from '../../../../../store/suppliers/units';

enum EnumRadioBtn {
  PARTNERS = 'PARTNERS',
  CONTAINERS = 'CONTAINERS'
}

enum EnumTabOffers {
  HISTORYOFFER = 'HISTORYOFFER',
  ALLOFFERS = 'ALLOFFERS',
  RECENTPROPOSAL = 'RECENTPROPOSAL',
  LASTANSWER = 'LASTANSWER',
  EXPIREDOFFERS = 'EXPIREDOFFERS',
  PARTNER = 'PARTNER',
  CONTAINER = 'CONTAINER'
}

const getTabOffers = (tab: EnumTabOffers, currentPage?: AuditOperation | SupplierUnitsProposalDto) => {
  switch (tab) {
    case EnumTabOffers.ALLOFFERS:
      return <AllOffers />;
    case EnumTabOffers.RECENTPROPOSAL:
      return <RecentOffers />;
    case EnumTabOffers.LASTANSWER:
      return <LastAnswer />;
    case EnumTabOffers.EXPIREDOFFERS:
      return <ExpiredOffers />;
    case EnumTabOffers.PARTNER:
      return currentPage ? <DetailPartner item={currentPage as SupplierUnitsProposalDto} /> : null;
    case EnumTabOffers.CONTAINER:
      return currentPage ? <DetailContainer item={currentPage as AuditOperation} /> : null;
    default:
      return <HistoryOffer />;
  }
};

const TabOffersTrad = {
  ALLOFFERS: 'audits.auditOfferFollowUp.tabs.allOffers',
  RECENTPROPOSAL: 'audits.auditOfferFollowUp.tabs.recentProposal',
  LASTANSWER:'audits.auditOfferFollowUp.tabs.lastAnswer',
  EXPIREDOFFERS: 'audits.auditOfferFollowUp.tabs.expiredOffer',
};

const DividerColored = styled(Divider)({
  border: '1px solid rgba(134, 143, 156, 0.18)',
});

const RadioBtn = styled(Radio)({
  width: '15px',
  height: '15px',
  '&.Mui-checked': {
    color: Colors.primary,
  }
});

const RadioLabels = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  color: '#192133',
  paddingLeft: '5px'
});

const AuditsOfferFollowUp = () => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState<EnumTabOffers>(EnumTabOffers.HISTORYOFFER);
  const [currentPage, setCurrentPage] = useState<AuditOperation | SupplierUnitsProposalDto>();
  const [radioBtn, setRadioBtn] = useState(EnumRadioBtn.PARTNERS);
  const { auditId } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [{ auditsOperation }] = useObservable(auditsOperationQuery.auditsOperationList$);
  const [{ auditDetails }] = useObservable(auditDetailsQuery.auditDetails$);
  const [version, setVersion] = useState<number>();
  const [{ allAuditsSupProposal }] = useObservable(auditsProposalSuppliersQuery.allAuditsSupProposal$);
  const suppliersUnits = allAuditsSupProposal ? allAuditsSupProposal : [];
  const benneArray = auditsOperation;
  const CurrentView = useMemo(() => getTabOffers(currentTab, currentPage), [currentTab, currentPage]);
  const tabs = Object.values(EnumTabOffers).filter((tab) => tab !== EnumTabOffers.PARTNER && tab !== EnumTabOffers.CONTAINER);

  useEffect(() => {
    if (auditDetails.id) {
      setVersion(auditDetails.currentVersion);
    }
  }, [auditDetails]);

  useEffect(() => {
    if (auditId) {
      auditProposalSuppliersServices.getAllAuditsSupProposal(auditId).subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
    }
  }, [auditId, enqueueSnackbar]);


  useEffect(() => {
    emitOnce(() => {
      auditsOperationService.setStep(AuditOperationStepTypeEnum.PRECO);
    });
    if (auditId) {
      auditsOperationService.getAuditsInformationOP(auditId).pipe().subscribe();
      suppliersUnitsService.getSuppliersUnits().pipe().subscribe();
    }

    if (auditDetails.id) {
      auditsOfferService.getAuditOffer(auditDetails.id, version ?? auditDetails.currentVersion).pipe(
        switchMap(() => auditsOperationService.getAuditsInformationOP(auditDetails.id)),
      ).subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
    }
    return () => {
      auditsOfferService.resetStore();
    };
  }, [auditId, auditDetails, enqueueSnackbar, version]);

  const handleCurrentPage = (item: SupplierUnitsProposalDto | AuditOperation) => {
    setCurrentPage(item);
    setCurrentTab(radioBtn === EnumRadioBtn.PARTNERS ? EnumTabOffers.PARTNER : EnumTabOffers.CONTAINER);
  };

  const handleChangeRadioBtn = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRadioBtn(event.target.value as EnumRadioBtn);
  };

  const handleSetTabs = (tab: EnumTabOffers) => {
    setCurrentTab(tab);
  };

  return (
    <Stack direction={'row'} spacing={2} py={'20px'} height={'100%'} maxHeight={'calc(100dvh - 14rem)'}>
      <Stack bgcolor={Colors.white} borderRadius={'4px'} maxWidth={'269px'} >
        <Stack p="20px" >
          <Button startIcon={<Add />} variant="contained" color="primary" onClick={() => setOpenModal(true)}>
            {t('audits.auditOfferFollowUp.buttons.newOffer')}
          </Button>
        </Stack >
        {
          tabs.map((tab, idx) => (
            <Fragment key={idx}>
              <DividerColored />
              <Stack
                onClick={() => handleSetTabs(tab)}
                sx={{
                  cursor: 'pointer',
                  color: currentTab === tab ? Colors.primary : Colors.black,
                  borderLeft: currentTab === tab ? `5px solid ${Colors.primary}` : '5px solid transparent',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography fontSize="14px" fontWeight={500} p="15px">
                  {idx > 0 ? t(TabOffersTrad[tab]) : t('audits.auditOfferFollowUp.tabs.historyOffers')}
                </Typography>
              </Stack >
              {tabs.length - 1 === idx && <DividerColored />}
            </Fragment>
          ))
        }
        <Stack mt='14px' mb='15px' px='20px' width='100%' justifyContent='center' alignItems='center' >
          <RadioGroup row defaultValue={EnumRadioBtn.PARTNERS} name="radio-buttons-group" value={radioBtn} onChange={handleChangeRadioBtn} sx={{ flexWrap: 'nowrap' }}>
            <FormControlLabel value={EnumRadioBtn.PARTNERS} control={<RadioBtn />} label={
              <RadioLabels>
                {t('audits.auditOfferFollowUp.radioBtn.partners')}
              </RadioLabels>
            } />
            <FormControlLabel value={EnumRadioBtn.CONTAINERS} control={<RadioBtn />} label={
              <RadioLabels>
                {t('audits.auditOfferFollowUp.radioBtn.containers')}
              </RadioLabels>
            } />
          </RadioGroup>
          <Box width="100%" mt='10px' >
            <SearchComponent
              isCustom
              handleChange={() => undefined}
              placeholder={radioBtn === EnumRadioBtn.PARTNERS ? t('audits.auditOfferFollowUp.searchPartnersPlaceholder') : t('audits.auditOfferFollowUp.searchContainersPlaceholder')}
              bgColor="#F4F6F8"
            />
          </Box>
        </Stack >
        <Stack overflow={'auto'} justifySelf='end' mr="5px">
          {(radioBtn === EnumRadioBtn.PARTNERS ? suppliersUnits : benneArray).map((item, idx) => (
            <Stack
              key={idx}
              onClick={() => handleCurrentPage(item)}
              sx={{
                cursor: 'pointer',
                borderLeft: currentPage === item ? `5px solid ${Colors.primary}` : '5px solid transparent',
                alignItems: 'left',
                px: '20px',
              }}
            >
              <Stack>
                {idx !== 0 && <DividerColored />}
                <Stack direction={'row'} alignItems='center' spacing={1}>
                  {radioBtn === EnumRadioBtn.PARTNERS ?
                    <BlackServicesInactive style={{ height: '16px', width: '16px', flex: 'none' }} /> :
                    <Stack sx={{
                      backgroundColor: '#4F3FF5',
                      borderRadius: '3px',
                      alignItems: 'center',
                      padding: '4px',
                      justifyContent: 'center',
                      width: '20px',
                      height: '20px'
                    }}>
                      <InventoryIcon sx={{ color: 'white', width: '15px', height: '15px' }} />
                    </Stack>}
                  <Stack direction={radioBtn === EnumRadioBtn.PARTNERS ? 'row' : 'column'} alignItems='flex-start' p={'15px 0px'} spacing={0.5}>
                    <Typography fontSize="14px" fontWeight={500}>
                      {radioBtn === EnumRadioBtn.PARTNERS ? item.name : item?.type == 'CUSTOM' ? item?.containerCustom : item?.container?.name}
                    </Typography>
                    {radioBtn === EnumRadioBtn.CONTAINERS ? (
                      <Typography fontSize="12px" fontWeight={500} color={Colors.lightGrey} alignSelf='start'>
                        {item.waste.name || ''}
                      </Typography>
                    )
                      : undefined}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack >
      <Stack flex={1} bgcolor={Colors.white} borderRadius={'4px'}>
        {CurrentView}
      </Stack >
      {
        openModal ? (
          <NewProposal
            handleClose={() => setOpenModal(false)}
            handleSetTab={() => setCurrentTab(EnumTabOffers.ALLOFFERS)} />
        ) : undefined
      }
    </Stack >
  );
};

export default AuditsOfferFollowUp;
